import { render, staticRenderFns } from "./GstReportView.vue?vue&type=template&id=19e49778"
import script from "./GstReportView.vue?vue&type=script&lang=js"
export * from "./GstReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e49778')) {
      api.createRecord('19e49778', component.options)
    } else {
      api.reload('19e49778', component.options)
    }
    module.hot.accept("./GstReportView.vue?vue&type=template&id=19e49778", function () {
      api.rerender('19e49778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstReportView.vue"
export default component.exports